// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { type VMessageTemplateContext } from '../../index.ts';

import { AssertError } from '@atlassian/vindicated';
export function assert(value: any): VMessageTemplateContext {
    const result = validate(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new AssertError('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data as VMessageTemplateContext;
}
export { assert as assertMessageTemplateContext };


export function is(value: any): value is VMessageTemplateContext {
	const result = validate(value);
    return result.success;
}
export { is as isMessageTemplateContext };


import { type ValidationResult } from '@atlassian/vindicated';
export function validate(value: any): ValidationResult<VMessageTemplateContext> {
    const errors = [];
    const originalData = value;
    
	if (typeof value !== 'object' || value === null || Array.isArray(value)) {
        errors.push({ path: 'value', expected: 'MessageTemplateContext', value: value });
    } else {
			if (!('product' in value)) {
				errors.push({ path: 'value["product"]', expected: '"jira" | "confluence" | "jira-confluence"', value: undefined });
			} else {
				
    {
        let value__product___valid = false;
        
        if (!value__product___valid) {
            const value__product___errors_0 = [];
            if (value["product"] !== "jira") value__product___errors_0.push({ path: 'value["product"]', expected: "jira", value: value["product"] });
            if (value__product___errors_0.length === 0) {
                value__product___valid = true;
            }
        }

        if (!value__product___valid) {
            const value__product___errors_1 = [];
            if (value["product"] !== "confluence") value__product___errors_1.push({ path: 'value["product"]', expected: "confluence", value: value["product"] });
            if (value__product___errors_1.length === 0) {
                value__product___valid = true;
            }
        }

        if (!value__product___valid) {
            const value__product___errors_2 = [];
            if (value["product"] !== "jira-confluence") value__product___errors_2.push({ path: 'value["product"]', expected: "jira-confluence", value: value["product"] });
            if (value__product___errors_2.length === 0) {
                value__product___valid = true;
            }
        }
        if (!value__product___valid) {
            errors.push({ path: 'value["product"]', expected: '"jira" | "confluence" | "jira-confluence"', value: value["product"] });
        }
    }
			}
			if (!('cloudId' in value)) {
				errors.push({ path: 'value["cloudId"]', expected: 'string', value: undefined });
			} else {
				if (typeof value["cloudId"] !== 'string') errors.push({ path: 'value["cloudId"]', expected: 'string', value: value["cloudId"] });
			}
			if ('orgId' in value && value['orgId'] !== undefined) {
				if (typeof value["orgId"] !== 'string') errors.push({ path: 'value["orgId"]', expected: 'string', value: value["orgId"] });
			}
			if ('twcEntitlementId' in value && value['twcEntitlementId'] !== undefined) {
				if (typeof value["twcEntitlementId"] !== 'string') errors.push({ path: 'value["twcEntitlementId"]', expected: 'string', value: value["twcEntitlementId"] });
			}
			if ('redirectTo' in value && value['redirectTo'] !== undefined) {
				
    {
        let value__redirectTo___valid = false;
        
        if (!value__redirectTo___valid) {
            const value__redirectTo___errors_0 = [];
            if (value["redirectTo"] !== "jira") value__redirectTo___errors_0.push({ path: 'value["redirectTo"]', expected: "jira", value: value["redirectTo"] });
            if (value__redirectTo___errors_0.length === 0) {
                value__redirectTo___valid = true;
            }
        }

        if (!value__redirectTo___valid) {
            const value__redirectTo___errors_1 = [];
            if (value["redirectTo"] !== "confluence") value__redirectTo___errors_1.push({ path: 'value["redirectTo"]', expected: "confluence", value: value["redirectTo"] });
            if (value__redirectTo___errors_1.length === 0) {
                value__redirectTo___valid = true;
            }
        }
        if (!value__redirectTo___valid) {
            errors.push({ path: 'value["redirectTo"]', expected: '"jira" | "confluence"', value: value["redirectTo"] });
        }
    }
			}
			if (!('recommendedApp' in value)) {
				errors.push({ path: 'value["recommendedApp"]', expected: '"confluence" | "jira" | "loom"', value: undefined });
			} else {
				
    {
        let value__recommendedApp___valid = false;
        
        if (!value__recommendedApp___valid) {
            const value__recommendedApp___errors_0 = [];
            if (value["recommendedApp"] !== "confluence") value__recommendedApp___errors_0.push({ path: 'value["recommendedApp"]', expected: "confluence", value: value["recommendedApp"] });
            if (value__recommendedApp___errors_0.length === 0) {
                value__recommendedApp___valid = true;
            }
        }

        if (!value__recommendedApp___valid) {
            const value__recommendedApp___errors_1 = [];
            if (value["recommendedApp"] !== "jira") value__recommendedApp___errors_1.push({ path: 'value["recommendedApp"]', expected: "jira", value: value["recommendedApp"] });
            if (value__recommendedApp___errors_1.length === 0) {
                value__recommendedApp___valid = true;
            }
        }

        if (!value__recommendedApp___valid) {
            const value__recommendedApp___errors_2 = [];
            if (value["recommendedApp"] !== "loom") value__recommendedApp___errors_2.push({ path: 'value["recommendedApp"]', expected: "loom", value: value["recommendedApp"] });
            if (value__recommendedApp___errors_2.length === 0) {
                value__recommendedApp___valid = true;
            }
        }
        if (!value__recommendedApp___valid) {
            errors.push({ path: 'value["recommendedApp"]', expected: '"confluence" | "jira" | "loom"', value: value["recommendedApp"] });
        }
    }
			}
			if (!('actionTier' in value)) {
				errors.push({ path: 'value["actionTier"]', expected: '"high" | "medium" | "low"', value: undefined });
			} else {
				
    {
        let value__actionTier___valid = false;
        
        if (!value__actionTier___valid) {
            const value__actionTier___errors_0 = [];
            if (value["actionTier"] !== "high") value__actionTier___errors_0.push({ path: 'value["actionTier"]', expected: "high", value: value["actionTier"] });
            if (value__actionTier___errors_0.length === 0) {
                value__actionTier___valid = true;
            }
        }

        if (!value__actionTier___valid) {
            const value__actionTier___errors_1 = [];
            if (value["actionTier"] !== "medium") value__actionTier___errors_1.push({ path: 'value["actionTier"]', expected: "medium", value: value["actionTier"] });
            if (value__actionTier___errors_1.length === 0) {
                value__actionTier___valid = true;
            }
        }

        if (!value__actionTier___valid) {
            const value__actionTier___errors_2 = [];
            if (value["actionTier"] !== "low") value__actionTier___errors_2.push({ path: 'value["actionTier"]', expected: "low", value: value["actionTier"] });
            if (value__actionTier___errors_2.length === 0) {
                value__actionTier___valid = true;
            }
        }
        if (!value__actionTier___valid) {
            errors.push({ path: 'value["actionTier"]', expected: '"high" | "medium" | "low"', value: value["actionTier"] });
        }
    }
			}
			if ('targetTenantId' in value && value['targetTenantId'] !== undefined) {
				if (typeof value["targetTenantId"] !== 'string') errors.push({ path: 'value["targetTenantId"]', expected: 'string', value: value["targetTenantId"] });
			}
			if ('collectionEntitlementId' in value && value['collectionEntitlementId'] !== undefined) {
				if (typeof value["collectionEntitlementId"] !== 'string') errors.push({ path: 'value["collectionEntitlementId"]', expected: 'string', value: value["collectionEntitlementId"] });
			}
    }
    if (errors.length === 0) return { success: true, data: value };
    return { success: false, data: originalData, errors: errors };
}
export { validate as validateMessageTemplateContext };
